import React from 'react';
import { Field, reduxForm, change, formValueSelector, touch } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash'

import renderField from '../../../../customInputs/renderField';
import renderSelect from '../../../../customInputs/renderSelect';
import fileInput from '../../../../customInputs/fileInput';
import renderTypeAhead from '../../../../customInputs/renderTypeAhead';
import renderRemovable from '../../../../customInputs/renderRemovable';

import Utils from '../../../../../lib/utils';
//import asyncValidate from './asyncValidation';
import validate from './validation';

import * as holdersActions from '../../../holders/actions';
import { createNumberMask } from 'redux-form-input-masks';
// import * as departmentsAction from '../../../settings/departments/actions';
import * as departmentsActions from '../../../../certfocus/settings/departments/actions';
import Select from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as loadApplyOptions from '../../../../common/countyDropdownActions/loadOptions'
import * as applyActions from '../../../../common/countyDropdownActions/actions'

const currencyMask = createNumberMask({
  prefix: 'US$ ',
  decimalPlaces: 2,
  locale: 'en-US',
})
const SelectAsyncOptions = ({ input, meta, dispatch, ...props }) => {
  const touchedError = meta.touched && meta.error;
  const name = input.name;
  const baseClassName = `${props.className || ''} select-${name}`;
  const errorClassName = `${touchedError ? `${baseClassName}-error` : ''}`;
  
return (
  <React.Fragment>
      <AsyncPaginate
        {...input}
        {...props}
        openMenuOnClick={true}
        closeMenuOnScroll={true}
        cacheOptions={true}
        pageSize={10}
        additional={{ page: 1 }}
        classNamePrefix="vk"
        className={`${baseClassName} ${errorClassName}`}
        menuPlacement="auto"
        onFocus={(_) => { }}
        onBlur={() => meta.dispatch(touch('HolderInfoForm', name))}
        onChange={(newValue) => input.onChange(newValue)}
        captureMenuScroll={true}
        closeMenuOnSelect={true}
        debounceTimeout={300}
        loadOptionsOnMenuOpen={true}
    />
    {touchedError && (
      <span className="select-error-message field-validation-message">
        {meta.error}
      </span>
      )}
    </React.Fragment>
  );
};
  
class HolderInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.selectInputRef = React.createRef();
    const { profile } = this.props;
    this.state = {
      managers : [],
      selectedCountry: profile && profile.CountryId || 1
    }
    if (profile) {
      //console.log(profile);
      let parentObj = null;
      const { parentId, parentName } = profile;
      if (profile.parentId) {
        parentObj = {
          value: parentId,
          label: parentName
        }
      }

      if (profile.department) {
        const queryParams = {
          departmentId: profile.department,
        }
        this.props.departmentsAction.getDepartmentUsers(queryParams)
      } else {
        this.props.departmentsAction.setDepartmentUsers([]);
      }

      props.dispatch(change('HolderInfoForm', 'holderName', profile.name || ""));
      props.dispatch(change('HolderInfoForm', 'parentHolder', parentObj || null));
      props.dispatch(change('HolderInfoForm', 'address1', profile.address1 || ""));
      if (profile.address2 !== "not available") {
        props.dispatch(change('HolderInfoForm', 'address2', profile.address2 || ""));
      }
      props.dispatch(change('HolderInfoForm', 'city', profile.city || ""));
      props.dispatch(change('HolderInfoForm', 'stateId', {value:profile.StateId,label:profile.StateName} || ""));
      props.dispatch(change('HolderInfoForm', 'postalCode', profile.zipCode || ""));
      props.dispatch(change('HolderInfoForm', 'countryId', {value:profile.CountryId,label:profile.CountryName} || ""));
      props.dispatch(change('HolderInfoForm', 'department', profile.department || ""));
      props.dispatch(change('HolderInfoForm', 'intOfficeID', profile.intOfficeID || ""));

      props.dispatch(change('HolderInfoForm', 'contactName', profile.contactName || ""));
      props.dispatch(change('HolderInfoForm', 'contactPhone', profile.phone || ""));
      props.dispatch(change('HolderInfoForm', 'contactEmail', profile.contactEmail || ''));
      props.dispatch(change('HolderInfoForm', 'contactId', profile.contactId || ""));
      props.dispatch(change('HolderInfoForm', 'accountManager', profile.accountManagerId ? profile.accountManagerId.trim() :""|| ""));
      props.dispatch(change('HolderInfoForm', 'initialFee', profile.initialFee || ""));
      props.dispatch(change('HolderInfoForm', 'initialCredits', profile.initialCredits || ""));
      props.dispatch(change('HolderInfoForm', 'addlFee', profile.addlFee || ""));
      props.dispatch(change('HolderInfoForm', 'addlCredits', profile.addlCredits || ""));

      props.dispatch(change('HolderInfoForm', 'portalHomepageText', profile.PortalHomepageText || ""));
      props.dispatch(change('HolderInfoForm', 'portalFaqText', profile.PortalFaqText || ""));

      props.dispatch(change('HolderInfoForm', 'note', profile.note || ""));

      props.dispatch(change('HolderInfoForm', 'emailAliasAddress', profile.emailAliasAddress || ""));
      props.dispatch(change('HolderInfoForm', 'emailAliasName', profile.emailAliasName || ""));
      if (profile.portalURL !== "not available") {
        props.dispatch(change('HolderInfoForm', 'subdomain', profile.portalURL || ""));
      }
    }else{
    this.props.dispatch(change('HolderInfoForm', 'countryId', {value:1,label:"United States"}));
    }
  }
  componentDidMount(){
    const { profile } = this.props;
    if(profile && profile.accountManagerId){
      this.setState({
        managers : JSON.parse(profile.accountManagerId.trim())
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    const self = this;
    function previewFile() {
      const file = document.querySelector('input[type=file]').files[0];
      const reader = new FileReader();

      reader.onloadend = function () {
        let style = document.getElementById('upload-file-wrapper').style;
        style.background = `url(${reader.result})`;
        //style.backgroundSize = 'cover';
        style.backgroundSize = 'contain';
        style.backgroundRepeat = 'no-repeat';
        style.backgroundPosition = 'center';
      }

      if (file) {
        reader.readAsDataURL(file);
      } else {
        self.props.dispatch(change('HolderInfoForm', 'companyLogo', ""));
        const currentLogo = _.get(self.props, 'profile.logo', null);
        let style = document.getElementById('upload-file-wrapper').style;
        if (currentLogo) {
          style.background = `url(data:image/jpg;base64,${currentLogo})`;
          //style.backgroundSize = 'cover';
          style.backgroundSize = 'contain';
          style.backgroundRepeat = 'no-repeat';
          style.backgroundPosition = 'center';
        } else {
          style.background = "none";
        }
      }
    }

    previewFile();
  }

  onRemoveParent = () => {
    this.props.actions.setParentHolders([]);
  }
  selectCountryFunction = (value) => {
    if(value !== this.state.selectedCountry){
      this.props.dispatch(change('HolderInfoForm', 'stateId',  {value:null,label:''}));
    }
    this.setState({selectedCountry:value.value})
  }
  searchParents = (filterTerm) => {
    let excludeHolderId = null;
    const { profile } = this.props;
    if (profile) excludeHolderId = profile.id;
    this.props.actions.fetchParentHolders(filterTerm, excludeHolderId);
  }
  setAccountManagers = (val) =>{
    this.props.dispatch(change('HolderInfoForm', 'accountManager', val|| ""));
  }
  renderFormField = (element, idx) => {
    const {
      name, label, ph, options, type,
      conditional, show, handleSearch, tipLabel,
      handleCallback, loadOptions, placeholder, noWhitespace
    } = element;
    const style = {};
    if (conditional && !show) {
      style.display = 'none';
    }

    if (handleSearch) {
      const { fetching, results, error } = element;
      return (
        <div key={idx} className="wiz-field admin-form-field-wrapper" style={style}>
          <label htmlFor={name}>{`${label}:`}</label>
          <Field
            resetOnClick
            name={name}
            placeholder={ph}
            fetching={fetching}
            results={results}
            handleSearch={handleSearch}
            fetchError={error}
            component={renderTypeAhead}
          />
        </div>
      );
    }

    if (type === 'removable') {
      const { valueText, disabled, onRemove } = element;
      return (
        <div key={idx} className="wiz-field admin-form-field-wrapper" style={style}>
          <label htmlFor={name}>{`${label}:`}</label>
          <Field
            name={name}
            valueText={valueText}
            component={renderRemovable}
            onRemove={onRemove}
            disabled={disabled}
          />
        </div>
      );
    }
    return (
      <div key={idx} className="wiz-field admin-form-field-wrapper" style={style}>
        <label htmlFor={name}>{`${label}:`}</label>
        {
          tipLabel &&
          <span className="tip-span">
            {tipLabel}
          </span>
        }

        {
          loadOptions && name !== "accountManager" ? (
            <div className="select-wrapper">
              <div className="">
                <Field
                  name={name}
                  component={SelectAsyncOptions}
                  cacheUniqs={[this.state.selectedCountry]} 
                  loadOptions={loadOptions}
                  autoComplete="off"
                  placeholder={placeholder}
                  onChange={(value)=>name == "countryId" ? this.selectCountryFunction(value):null }
                  className={'accountManager'}
                />
              </div>
            </div>
          ) : options && name === "accountManager" ? (
            <div className="select-wrapper">
              <div className=''>
                    <Select
                      isMulti
                      ref={this.selectInputRef}
                      name={name}
                      value={this.state.managers}
                      isClearable={false}
                      isSearchable={true}
                      options={options}
                      placeholder={'Select Manager'}
                      onChange={(val) => {this.setState({managers : val}) ;this.setAccountManagers(val)}}
                      className={'accountManager'}
                    />
            </div>
            </div>
          ) : options && name === "department" ? (
            <div className="select-wrapper">
              <Field
                name={name}
                component={renderSelect}
                options={options}
                callback={handleCallback ? (val) => handleCallback(val) : null}
              />
            </div>
          ) :(
              (type === 'currency') ? (
                <Field
                  name={name}
                  type="text"
                  placeholder={ph}
                  component={renderField}
                  {...currencyMask}
                />
              ) : (
                  <Field
                    name={name}
                    type={type || 'text'}
                    placeholder={ph}
                    component={renderField}
                    noWhitespace={noWhitespace}
                  />
                )
            )
        }
      </div>
    );
  }

  onDepartmentsChange = (id) => {
    if (id) {
      const queryParams = {
        departmentId: id,
      }
      this.props.departmentsAction.getDepartmentUsers(queryParams);
    } else {
      this.props.dispatch(change('HolderInfoForm', 'accountManager', ""));
      this.props.departmentsAction.setDepartmentUsers([]);
    }
    this.selectInputRef.current.select.clearValue();
  }

  
  render() {
    const {
      handleSubmit,
      currentParentHolder,
      currentCountry,
      currentSubdomain,
    } = this.props;

    const {
      labelPortalUrl,
      portalUrlSufix,
      labelHolderName,
      labelParentHolder,
      labelAddress1,
      labelAddress2,
      labelCity,
      labelState,
      labelPostalCode,
      labelCountry,
      labelDepartment,
      labelIntOfficeId,
      labelContactName,
      labelContactPhone,
      labelContactEmail,
      labelAccountManager,
      labelInitialFee,
      labelInitialCredits,
      labelAddlFee,
      labelAddlCredits,
      cancelButton,
      saveButton,
      selectManagerPlaceholder,
      selectCountryPlaceholder,
      labelCompanyLogo,
      departmentsPlaceholder,
      portalHomeText,
      note,
      portalFAQ,
      labelEmailAliasName,
      labelEmailAliasAddress,
    } = this.props.local.strings.holders.addHolderModal.holderInfoTab;

    const { fetchingParents, parentsList, errorHolders } = this.props.holders;
    const holderOptions = Utils.getOptionsList(null, parentsList, 'name', 'id', 'name');
    const departmentsOptions = Utils.getOptionsList(`-- ${departmentsPlaceholder} --`, this.props.departments.list, 'name', 'id', 'name');
    const managerOptions = Utils.getOptionsList(`-- ${selectManagerPlaceholder} --`, this.props.departments.currentDepartmentUsers, 'Name', 'Id', 'name');
    const countryOptions = this.props.actions.loadCountries(this.props);
    const stateOptions = this.props.actions.loadStates(this.props,this.state.selectedCountry);
    const parent = currentParentHolder || null;
    // const country = currentCountry || '';
    
    const { profile } = this.props.login;
    let canChangeParent = false;
    if (profile.CFRole) {
      canChangeParent = ([8, 10, 12].indexOf(profile.CFRole.Id) > -1);
    }
    const subdomain = currentSubdomain || 'subdomain';
    const companyLogoFieldLabel = _.get(this.props, 'currentForm.HolderInfoForm.values.companyLogo.name', labelCompanyLogo);
    
    const leftFields = [
      { name: 'holderName', label: labelHolderName, ph: `-- ${labelHolderName} --` },
      {
        name: 'parentHolder', label: labelParentHolder, ph: `-- ${labelParentHolder} --`,
        handleSearch: this.searchParents, fetching: fetchingParents, results: holderOptions,
        error: errorHolders, conditional: true, show: canChangeParent && !parent
      },
      {
        name: 'parentHolder', label: labelParentHolder, type: 'removable',
        valueText: parent ? parent.label : '', onRemove: this.onRemoveParent,
        disabled: !canChangeParent, conditional: true, show: parent
      },
      { name: 'address1', label: labelAddress1, ph: `-- ${labelAddress1} --` },
      { name: 'address2', label: labelAddress2, ph: `-- ${labelAddress2} --` },
      { name: 'city', label: labelCity, ph: `-- ${labelCity} --` },
      { name: 'stateId', label: labelState, loadOptions:stateOptions, placeholder:"Select State"},
      { name: 'countryId', label: labelCountry ,loadOptions:countryOptions , placeholder:selectCountryPlaceholder},
      { name: 'postalCode', label: labelPostalCode, ph: `-- ${labelPostalCode} --` },
      // { name: 'department', label: labelDepartment, ph: `-- ${labelDepartment} --` },
      { name: 'department', label: labelDepartment, options: departmentsOptions, handleCallback: this.onDepartmentsChange },
      { name: 'intOfficeID', label: labelIntOfficeId, ph: `-- ${labelIntOfficeId} --` },
      { name: 'portalHomepageText', label: portalHomeText.label, ph: portalHomeText.ph, type: 'textarea' },
      { name: 'note', label: note.label, ph: note.ph, type: 'textarea' },
    ]
    const rightFields = [
      { name: 'contactName', label: labelContactName, ph: `-- ${labelContactName} --` },
      { name: 'contactPhone', label: labelContactPhone, ph: `-- ${labelContactPhone} --` },
      { name: 'contactEmail', label: labelContactEmail, ph: `-- ${labelContactEmail} --`, noWhitespace: true },
      { name: 'initialFee', label: labelInitialFee, ph: `-- ${labelInitialFee} --`, type: 'currency' },
      { name: 'initialCredits', label: labelInitialCredits, ph: `-- ${labelInitialCredits} --`, type: 'currency' },
      { name: 'addlFee', label: labelAddlFee, ph: `-- ${labelAddlFee} --`, type: 'currency' },
      { name: 'addlCredits', label: labelAddlCredits, ph: `-- ${labelAddlCredits} --`, type: 'currency' },
      { name: 'subdomain', label: labelPortalUrl, ph: `-- ${labelPortalUrl} --`, tipLabel: `${subdomain}${portalUrlSufix} `, noWhitespace: true },
      { name: 'accountManager', label: labelAccountManager, options: managerOptions },
      { name: 'emailAliasAddress', label: labelEmailAliasAddress, ph: '', noWhitespace: true },
      { name: 'emailAliasName', label: labelEmailAliasName, ph: ''},
      { name: 'portalFaqText', label: portalFAQ.label, ph: portalFAQ.ph, type: 'textarea' },
    ];

    return (
      <form
        onSubmit={handleSubmit}
        className="entity-info-form wiz-form"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <div className="upload-file-wrapper">
                <label id="upload-file-wrapper" htmlFor="companyLogo">
                  {`${companyLogoFieldLabel}`}
                </label>
                <Field
                  name="companyLogo"
                  id="companyLogo"
                  component={fileInput}
                />
              </div>
            </div>
            <div className="col-md-8 col-sm-12">
              <div className="row">
                <div className="col-md-6 col-sm-12 " >
                  {leftFields.map(this.renderFormField)}
                </div>
                <div className="col-md-6 col-sm-12">
                  {rightFields.map(this.renderFormField)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wiz-buttons">
          <a className="wiz-cancel-button" onClick={this.props.close}>{cancelButton}</a>
          <button className="wiz-continue-btn bg-sky-blue-gradient bn">{saveButton}</button>
        </div>

      </form>
    );
  }
};

HolderInfoForm = reduxForm({
  form: 'HolderInfoForm',
  validate,
  //asyncValidate,
  //asyncBlurFields: ['holderName'],
})(HolderInfoForm);

const mapStateToProps = (state) => {
  return {
    currentForm: state.form,
    local: state.localization,
    holders: state.holders,
    common: state.common,
    login: state.login,
    currentParentHolder: formValueSelector('HolderInfoForm')(state, 'parentHolder'),
    currentCountry: formValueSelector('HolderInfoForm')(state, 'country'),
    currentSubdomain: formValueSelector('HolderInfoForm')(state, 'subdomain'),
    companyLogo: formValueSelector('HolderInfoForm')(state, 'companyLogo') || null,
    departments: state.departments,
    initialValues: {
      department: '',
      accountManager: '',
    }
  };
};




const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      ...bindActionCreators(applyActions, dispatch),
      ...loadApplyOptions,
      ...bindActionCreators(holdersActions, dispatch),
    },
    departmentsAction: bindActionCreators(departmentsActions, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(HolderInfoForm);
